import React from 'react';
import { changeYarnPOApprovalStatus } from '../../../store/programs/YarnPO/yarnPODetails/yarnPODetails.actions';
import { useDispatch } from 'react-redux';

import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import axios from 'axios';
import Cookies from 'js-cookie';
import Config from '../../../config';
import ConstantApi from '../../../ConstantApi';
import { LOADING_MODAL_OPEN } from '../../../store/actions';
import { useSelector } from '../../../store/reducer';

function VerifyBtn({ selectedValue, selectedId, code, navigateDetail, requestFailure, request, url, DCSelectedValue, fnCall }) {
    let dispatch = useDispatch();

    let { isLoaderModal } = useSelector((state) => {
        return state.able;
    });

    React.useEffect(() => {
        if (isLoaderModal) {
            return Swal.fire({
                html: `
              <div class="custom-loader-container">
                <div class="custom-loader"></div>
                <div class="custom-loader"></div>
                <div class="custom-loader"></div>
                <div class="custom-loader"></div>
                <p class="loading-text">Processing Please Wait...</p>
              </div>
            `,
                text: 'Please Wait...',
                allowOutsideClick: false,
                showConfirmButton: false,
                customClass: {
                    popup: 'custom-popup'
                }
            });
        } else {
            Swal.close();
        }
    }, [isLoaderModal]);

    const updateClick = (e) => {
        dispatch({ type: LOADING_MODAL_OPEN });
        dispatch(changeYarnPOApprovalStatus(selectedValue.fldId, 0, code, navigateDetail, requestFailure, request, url, DCSelectedValue, fnCall));

    };
    const updateClick_verify = (e) => {
        dispatch({ type: LOADING_MODAL_OPEN });
        dispatch(changeYarnPOApprovalStatus(selectedValue.fldId, 1, code, navigateDetail, requestFailure, request, url, DCSelectedValue, fnCall));

    };

    const updateClick_authorizeFabric = (e) => {
        var config = {
            method: 'post',
            url: `${Config.baseUrl}${ConstantApi.authorizeSendVerifyOTPForfabricPO}?FabricFldId=${selectedValue?.fldId}&FldPONO=${selectedValue?.fldPoNo}&FldFKStyle=${selectedValue?.fldFKStyle}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                if (response?.data === 200) {
                    dispatch(
                        changeYarnPOApprovalStatus(
                            selectedValue.fldId,
                            2,
                            code,
                            navigateDetail,
                            requestFailure,
                            request,
                            url,
                            DCSelectedValue,
                            fnCall
                        )
                    );
                } else {
                    toast.success('OTP Generated successfully', { autoClose: 1500 });
                    Swal.fire({
                        title: 'Enter OTP',
                        html: `<input type="text" id="login_otp" focus="true" class="swal2-input" placeholder="Please Enter your OTP">`,
                        confirmButtonText: 'Confirm',
                        showCancelButton: true,
                        cancelButtonColor: 'grey',
                        allowOutsideClick: false,
                        reverseButtons: true,
                        focusConfirm: false,
                        allowEscapeKey: false,
                        preConfirm: () => {
                            const login = Swal.getPopup().querySelector('#login_otp').value;
                            if (!login) {
                                Swal.showValidationMessage(`Please enter otp`);
                            } else if (login.length < 4) {
                                Swal.showValidationMessage(`Digit must be 4 digit`);
                            } else {
                                if (Number(response?.data) !== Number(login)) {
                                    Swal.showValidationMessage(`Please Verify OTP`);
                                }
                                return { login: login };
                            }
                        }
                    }).then(async (result) => {
                        if (result?.dismiss !== 'cancel') {
                            dispatch(
                                changeYarnPOApprovalStatus(
                                    selectedValue.fldId,
                                    2,
                                    code,
                                    navigateDetail,
                                    requestFailure,
                                    request,
                                    url,
                                    DCSelectedValue,
                                    fnCall
                                )
                            );
                        }
                    });
                }
            })
            .catch((error) => {
                toast.error('OTP Not Generated', { autoClose: 1500 });
            });
    };
    const updateClick_authorizeYarn = (e) => {
        var config = {
            method: 'post',
            url: `${Config.baseUrl}${ConstantApi.authorizeSendVerifyOTPForYarnPO}?FldFKYarn=${selectedValue?.fldId}&FldPONO=${selectedValue?.fldPoNo}&FldFKStyle=${selectedValue?.fldFKStyle}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                if (response?.data === 200) {
                    dispatch(
                        changeYarnPOApprovalStatus(
                            selectedValue.fldId,
                            2,
                            code,
                            navigateDetail,
                            requestFailure,
                            request,
                            url,
                            DCSelectedValue,
                            fnCall
                        )
                    );
                } else {
                    toast.success('OTP Generated successfully', { autoClose: 1500 });
                    Swal.fire({
                        title: 'Enter OTP',
                        html: `<input type="text" id="login_otp" focus="true" class="swal2-input" placeholder="Please Enter your OTP">`,
                        confirmButtonText: 'Confirm',
                        showCancelButton: true,
                        cancelButtonColor: 'grey',
                        allowOutsideClick: false,
                        reverseButtons: true,
                        focusConfirm: false,
                        allowEscapeKey: false,
                        preConfirm: () => {
                            const login = Swal.getPopup().querySelector('#login_otp').value;
                            if (!login) {
                                Swal.showValidationMessage(`Please enter otp`);
                            } else if (login.length < 4) {
                                Swal.showValidationMessage(`Digit must be 4 digit`);
                            } else {
                                if (Number(response?.data) !== Number(login)) {
                                    Swal.showValidationMessage(`Please Verify OTP`);
                                }
                                return { login: login };
                            }
                        }
                    }).then(async (result) => {
                        if (result?.dismiss !== 'cancel') {
                            dispatch(
                                changeYarnPOApprovalStatus(
                                    selectedValue.fldId,
                                    2,
                                    code,
                                    navigateDetail,
                                    requestFailure,
                                    request,
                                    url,
                                    DCSelectedValue,
                                    fnCall
                                )
                            );
                        }
                    });
                }
            })
            .catch((error) => {
                toast.error('OTP Not Generated', { autoClose: 1500 });
            });
    };
    const updateClick_authorize = (e) => {
        dispatch({ type: LOADING_MODAL_OPEN });
        if (code === 'GAP' || code === 'ACG' || code === 'DES') {
            dispatch(
                changeYarnPOApprovalStatus(
                    selectedValue.fldId,
                    2,
                    code,
                    navigateDetail,
                    requestFailure,
                    request,
                    url,
                    DCSelectedValue,
                    fnCall
                )
            );

        } else {

            if (code !== 'ACD') {
                var config = {
                    method: 'post',
                    url: `${Config.baseUrl}${ConstantApi.authorizeSendVerifyOTPForDyeingDC}?FldId=${selectedValue?.fldId}&FldDCNO=${selectedValue?.fldDCNo || selectedValue?.fldPONo || selectedValue?.fldPoNo}&FldFKStyle=${selectedValue?.fldFKStyle}&FldProgramCode=${code}`,
                    headers: {
                        // 'Access-Control-Allow-Origin': true,
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                        dbname: Cookies.get('DATABASE')
                    }
                };
                axios(config)
                    .then((response) => {
                        if (response?.data === 200) {
                            dispatch(
                                changeYarnPOApprovalStatus(
                                    selectedValue.fldId,
                                    2,
                                    code,
                                    navigateDetail,
                                    requestFailure,
                                    request,
                                    url,
                                    DCSelectedValue,
                                    fnCall
                                )
                            );
                        } else {
                            toast.success('OTP Generated successfully', { autoClose: 1500 });
                            Swal.fire({
                                title: 'Enter OTP',
                                html: `<input type="text" id="login_otp" focus="true" class="swal2-input" placeholder="Please Enter your OTP">`,
                                confirmButtonText: 'Confirm',
                                showCancelButton: true,
                                cancelButtonColor: 'grey',
                                allowOutsideClick: false,
                                reverseButtons: true,
                                focusConfirm: false,
                                allowEscapeKey: false,
                                preConfirm: () => {
                                    const login = Swal.getPopup().querySelector('#login_otp').value;
                                    if (!login) {
                                        Swal.showValidationMessage(`Please enter otp`);
                                    } else if (login.length < 4) {
                                        Swal.showValidationMessage(`Digit must be 4 digit`);
                                    } else {
                                        if (Number(response?.data) !== Number(login)) {
                                            Swal.showValidationMessage(`Please Verify OTP`);
                                        }
                                        return { login: login };
                                    }
                                }
                            }).then(async (result) => {
                                if (result?.dismiss !== 'cancel') {
                                    dispatch(
                                        changeYarnPOApprovalStatus(
                                            selectedValue.fldId,
                                            2,
                                            code,
                                            navigateDetail,
                                            requestFailure,
                                            request,
                                            url,
                                            DCSelectedValue,
                                            fnCall
                                        )
                                    );
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        toast.error('OTP Not Generated', { autoClose: 1500 });
                    });

            }
            if (code === 'ACD') {
                dispatch(
                    changeYarnPOApprovalStatus(
                        selectedValue.fldId,
                        2,
                        code,
                        navigateDetail,
                        requestFailure,
                        request,
                        url,
                        DCSelectedValue,
                        fnCall
                    )
                );
            }

        }
    };

    return (
        <div>
            <div>
                {!selectedValue?.fldIsPrepared ? (
                    <button
                        id="btnPrepared"
                        className="btn btn-danger text-white btn-sm m-0 justify-content-center"
                        type="button"
                        disabled={selectedId && selectedId.length <= 0}
                        onClick={updateClick}
                    >
                        Prepare
                    </button>
                ) : selectedValue?.fldIsPrepared && !selectedValue?.fldIsVerified ? (
                    <button
                        id="btnverified"
                        className=" btn btn-primary text-white btn-sm m-0 justify-content-center"
                        type="button"
                        // disabled={yarnPODetailsById && yarnPODetailsById.length <= 0}
                        onClick={updateClick_verify}
                    >
                        Verify
                    </button>
                ) : selectedValue?.fldIsPrepared && selectedValue?.fldIsVerified && !selectedValue?.fldIsAuthorized ? (
                    <button
                        id="btnauthorize"
                        className="btn btn-green btn-sm text-white m-0 justify-content-center"
                        type="button"
                        // disabled={yarnPODetailsById && yarnPODetailsById.length <= 0}
                        // disabled={checkAuthorizeBtnDisabled()}
                        onClick={
                            DCSelectedValue === 'yarnPOSelectedValue'
                                ? updateClick_authorizeYarn
                                : DCSelectedValue === 'singleFabricPoData'
                                    ? updateClick_authorizeFabric
                                    : updateClick_authorize
                        }
                    >
                        Authorize
                    </button>
                ) : (
                    <button
                        id="btnauthorized"
                        className="btn btn-green btn-sm text-white m-0 justify-content-center"
                        type="button"
                        onClick={
                            DCSelectedValue === 'yarnPOSelectedValue'
                                ? updateClick_authorizeYarn
                                : DCSelectedValue === 'singleFabricPoData'
                                    ? updateClick_authorizeFabric
                                    : updateClick_authorize
                        }
                        // disabled={yarnPODetailsById && yarnPODetailsById.length <= 0}
                        disabled={selectedValue?.fldInwardQty > 0 && true}
                    >
                        Authorized
                    </button>
                )}
            </div>
        </div>
    );
}

export default VerifyBtn;
